import React from 'react'
import SvgIcon from 'rambler-ui/icons/SvgIcon'

export default function MoslentaLogo ({width, height}) {
  return (
    <SvgIcon
      color='currentColor'
      style={{
        width: width,
        height: height
      }}
      viewBox='0 0 165 50'>
      <g fill='none' fillRule='evenodd'>
        <path
          fill='#CC4429'
          d='M51.072 27.514c0 .457-.056.914-1.28.914h-5.957v-4c0-.514.111-1.028 1.058-1.028h6.179v4.114zm94.583-6.686c-5.456 0-8.963 2.972-8.963 7.6h-3.006v-7.6h-2.616c-2.116 0-3.73.629-5.178 1.829v-1.828h-2.672c-2.115 0-3.897.685-5.288 1.942v-1.943h-2.561v7.6h-3.007v-7.6h-2.616V24.6h-7.293v-3.772H99.84v7.6H87.258v-1.257h7.737v-2.572h-7.737v-1.2h9.686v-2.57H84.641v7.6h-3.007v-7.6h-3.506c-5.4 0-8.908 2.97-8.908 7.6h-9.909v-4c0-.458.056-1.03 1.058-1.03h4.954v2.572h2.505v-5.143H44.893c-2.005 0-3.674 1.486-3.674 3.6v4h-2.951V17h-3.396c-2.672 0-4.955.743-6.402 2v-2h-3.34C19.563 17 16 19.971 16 24.543V31h2.617v-6.457c0-3.257 2.616-4.972 6.513-4.972h.723V31h2.617v-6.457c0-3.315 2.394-4.972 6.402-4.972h.78V31h14.14c2.505 0 3.896-1.657 3.896-3.486V23.4h3.173c-.11.171-.166.571-.166 1.028V31h15.142v-2.515c0-3.085 2.227-5.085 6.29-5.085h.891V31h23.437v-3.83h7.293V31h8.184v-2.458c0-3.143 2.06-5.085 5.288-5.085h.056V31h2.616v-2.571c0-3.143 1.949-4.972 5.178-4.972V31h8.239v-2.571h7.181V31h2.616V20.828h-3.45zm.835 2.572v2.514h-6.569c1.225-1.943 3.006-2.514 5.734-2.514h.835zM0 0v50V0zm165 0v50V0z'
        />
      </g>
    </SvgIcon>
  )
}
